import { z } from 'zod'

export const ExportSchema = z.object({
	report_type: z.string().min(1, 'Report type is required'),
	file_format: z.string().min(1, 'File format is required'),
	by_pricing_line: z.boolean().optional(),
})
